<script>
import { configComputed, configMethods } from '@/store/helpers'
import _ from 'lodash'

export default {
	name: 'RegionSelector',
	computed: {
		...configComputed,
		regionSelectorOptions() {
			const groupedRegions = _.groupBy(this.regions, 'datacenter')
			return _.toPairs(groupedRegions)
		},
		dropdownText() {
			const dataCenter = _.get(this.currentRegion, 'datacenter')
			const regionText = this.getDefaultRegionTranslation(
				this.currentRegion
			)
			const dataCenterText = dataCenter
				? this.$t(
						`PORTAL.Login.region_selector.data_center.${dataCenter}`
				  )
				: 'N/A'

			return `${dataCenterText} / ${regionText}`
		}
	},
	methods: {
		...configMethods,
		getDefaultRegionTranslation(region) {
			const defaultLanguage = _.get(region, 'defaultLanguage')
			const defaultTranslation = _.get(
				_.find(_.get(region, 'translations', []), {
					id: defaultLanguage
				}),
				'value',
				'N/A'
			)
			return defaultTranslation
		}
	}
}
</script>

<template>
	<div id="region-selector">
		<b-form-group :label="$t('PORTAL.Login.region_selector.label')">
			<b-dropdown
				class="region-selector-dropdown"
				toggle-class="region-selector-toggle"
				:text="dropdownText"
				block
				dropright
			>
				<b-dropdown-group
					v-for="[dataCenter, options] in regionSelectorOptions"
					:id="`dropdown-group-${dataCenter}`"
					:key="dataCenter"
					:header="
						$t(
							`PORTAL.Login.region_selector.data_center.${dataCenter}`
						)
					"
				>
					<b-dropdown-item-button
						v-for="option in options"
						:key="option.id"
						:active="currentRegion.id === option.id"
						@click="setCurrentRegion(option)"
					>
						{{ getDefaultRegionTranslation(option) }}
					</b-dropdown-item-button>
				</b-dropdown-group>
			</b-dropdown>
		</b-form-group>
	</div>
</template>

<style lang="scss" scoped>
@import '@/design/config/_custom-variables.scss';

#region-selector {
	::v-deep legend {
		font-weight: $font-weight-semibold;
	}

	.region-selector-dropdown {
		::v-deep > .region-selector-toggle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: transparent;
			outline: none;
			border-color: $border-color-white;
			box-shadow: none;
			color: $text-gray-color;
		}

		::v-deep > ul {
			width: 100%;
		}

		::v-deep .dropdown-menu {
			.dropdown-header {
				color: $primary-color;
			}

			button {
				color: $text-dark-color;
				padding-left: 40px;
			}
		}
	}
}
</style>
